import React from 'react';
import Layout from '../../layout';






function Ourhistory() {
  return (
   <Layout>
    <section class="page-header padding">
           <div class="overlay"></div>
            <div class="container">
               <div class="section-heading mt-40 text-center">
                    <h4 class="sub-heading">About Us</h4>
                    <h2>High Quality Construction Solutions <br/>For Residentials &amp; Industries!</h2>
                    <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                </div>
            </div>
        </section>

        <section class="about-section padding bd-bottom">
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="col-md-6 sm-padding">
                        <div class="section-heading mb-30">
                            <h2>We're Building Everything Best <br/>That You <span>Needed!</span></h2>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                        </div>
                        {/* <div class="row d-flex align-items-center">
                            <div class="col-md-6">
                                <div class="about-list">
                                    <div class="about-icon">
                                        <i class="dl dl-levels"></i>
                                    </div>
                                    <div class="about-content">
                                        <h3>Industrus Mission</h3>
                                        <p>Construction is a general term meaning the art and science to form objects systems.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="about-list">
                                    <div class="about-icon">
                                        <i class="dl dl-industrial-robot-8"></i>
                                    </div>
                                    <div class="about-content">
                                        <h3>Our Vision</h3>
                                        <p>Construction is a general term meaning the art and science to form objects systems.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sign">
                            <a href="#" class="default-btn">More about us <span></span></a>
                            <img src="assets/img/sign.png" alt="sign"/>
                        </div> */}
                    </div>
                    <div class="col-md-6 sm-padding">
                        <div class="about-img">
                            <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700073980/derma/icg06nimd9x78jrnxbsy.png" alt=""/>
                            <div class="exp-box">
                                <h3>25 Years Of <br/>Experiences</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="content-section-2 bd-bottom padding">
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="col-md-6 sm-padding">
                        <div class="content-thumb">
                            <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700582147/derma/vfckjnzbzkpas2fvbzdb.png" alt="post"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="section-heading">
                            <h2>Our <span>Mission</span></h2>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            {/* <p>Industrial is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction.</p> */}
                            <h2>Our <span>Vision</span></h2>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p>Industrial is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction.</p>
                            {/* <a href="#" class="default-btn">Get a Free quote <span></span></a> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="content-section-2 bd-bottom padding" style={{backgroundColor: '#eeeeee'}}>
            <div class="container">
                <div class="row d-flex align-items-center">
                <div class="col-md-6">
                        <div class="section-heading">
                            <h2>Our <span>Values</span></h2>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p></p>
                        </div>
                    </div>
                    <div class="col-md-6 sm-padding">
                        <div class="content-thumb">
                            <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700582145/derma/dxdbd3q9higzq2bh2pmg.png" alt="post"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="project-section bd-bottom">
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="col-md-6">
                        <div class="section-heading mb-40">
                            {/* <h4>Our Project</h4> */}
                            <h2>Transforming The Ideas And <br/>Visions For Industries!</h2>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="section-heading mb-40">
                            <p>Construction is a general term meaning the art and science to form <br/>objects systems organizations.</p>
                            <a href="project-4-col.html" class="default-btn">View our companies <span></span></a>
                        </div>
                    </div>
                </div>
                <div class="slider project-carousel nav-style dl-lb-gallery">
                    <div class="project-item">
                       <div class="project-thumb">
                           <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700581639/derma/b2oqfaap2yzd1dtdyth4.png" alt="project"/>
                            <div class="project-view">
                                <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700581639/derma/b2oqfaap2yzd1dtdyth4.png"><i class="fas fa-plus"></i></a>
                            </div>
                        </div>
                        <div class="project-content">
                            <h3><a href="project-4-col.html">Derm Group</a></h3>
                            <a href="project-4-col.html" class="cat">Learn more</a>
                        </div>
                    </div>
                    <div class="project-item">
                       <div class="project-thumb">
                           <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700581629/derma/ws9scb1i7p8dkzda7d9u.png" alt="project"/>
                           <div class="project-view">
                                <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700581629/derma/ws9scb1i7p8dkzda7d9u.png"><i class="fas fa-plus"></i></a>
                           </div>
                        </div>
                        <div class="project-content">
                            <h3><a href="project-4-col.html">Derm Elevators</a></h3>
                            <a href="project-4-col.html" class="cat">Learn more</a>
                        </div>
                    </div>
                    <div class="project-item">
                       <div class="project-thumb">
                           <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700581629/derma/yaj7tmaqvpzs97lym8cq.png" alt="project"/>
                            <div class="project-view">
                            <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700581629/derma/yaj7tmaqvpzs97lym8cq.png"><i class="fas fa-plus"></i></a>
                            </div>
                        </div>
                        <div class="project-content">
                            <h3><a href="project-4-col.html"> Coast Concrete Poles</a></h3>
                            <a href="project-4-col.html" class="cat">Learn more</a>
                        </div>
                    </div>
                    <div class="project-item">
                       <div class="project-thumb">
                           <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700581651/derma/aou5eql1awxcdftidy9m.png" alt="project"/>
                               <div class="project-view">
                                <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700581651/derma/aou5eql1awxcdftidy9m.png"><i class="fas fa-plus"></i></a>
                            </div>
                        </div>
                        <div class="project-content">
                            <h3><a href="project-4-col.html">Skyline Properties</a></h3>
                            <a href="project-4-col.html" class="cat">Learn more</a>
                        </div>
                    </div>
                    {/* <div class="project-item">
                       <div class="project-thumb">
                           <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700075885/derma/vyazyggnmftsgqabjjbc.png" alt="project"/>
                            <div class="project-view">
                                <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700075885/derma/vyazyggnmftsgqabjjbc.png"><i class="fas fa-plus"></i></a>
                            </div>
                        </div>
                        <div class="project-content">
                            <a href="project-4-col.html" class="cat">Realstate</a>
                            <h3><a href="project-4-col.html">Vincom Landmark 81</a></h3>
                        </div>
                    </div> */}
                </div>
             </div>
            <div class="counter-wrapper padding" style={{backgroundColor: 'transparent'}}>
               <div class="bg-pattern"></div>
                <div class="container">
                    <div class="row d-flex align-items-center mt-50">
                    <div class="col-lg-4 wow fadeInUp" data-wow-delay="200ms">
                        <div class="section-heading light">
                            <h4 style={{color: '#7B1113'}}>Some Facts</h4>
                            <h2 style={{color: '#7B1113'}}>Delivering The Most<br/> Innovation Goals!</h2>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6 sm-padding wow fadeInUp" data-wow-delay="300ms">
                        <div class="counter-item">
                            <div class="counter-content">
                                <h3><span style={{color: '#7B1113'}} class="odometer" data-count="3,245">00</span></h3>
                                <h4 style={{color: '#7B1113'}}>Projects Complete</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6 sm-padding wow fadeInUp" data-wow-delay="400ms">
                        <div class="counter-item">
                            <div class="counter-content">
                                <h3 style={{color: '#7B1113'}}><span class="odometer" data-count="2,518">00</span></h3>
                                <h4 style={{color: '#7B1113'}}>Happy Customer</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6 sm-padding wow fadeInUp" data-wow-delay="500ms">
                        <div class="counter-item">
                            <div class="counter-content">
                                <h3 style={{color: '#7B1113'}}><span class="odometer" data-count="6274">00</span></h3>
                                <h4 style={{color: '#7B1113'}}>Hours Worked</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6 sm-padding wow fadeInUp" data-wow-delay="600ms">
                        <div class="counter-item">
                            <div class="counter-content">
                                <h3 style={{color: '#7B1113'}}><span class="odometer" data-count="3245">00</span></h3>
                                <h4 style={{color: '#7B1113'}}>Worldwide Brunch</h4>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
        {/* <section class="content-section padding">
           <div class="left-pattern"></div>
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="col-md-6 sm-padding">
                        <div class="section-heading">
                            <h2>Construction Services With <br/>Architectural <span>Expertise!</span></h2>
                            <p>Construction is a general term meaning the art and science to form the <br/> objects systems organizations, and comes from Latin construction and <br/>French construction. To construct is the verb the act of main industrial building, and the noun is construction.</p>
                            <a href="#" class="default-btn">Read more <span></span></a>
                        </div>
                    </div>
                    <div class="col-md-6 sm-padding">
                        <div class="content-thumb">
                            <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/09/post-1-1024x683.jpg" alt="post"/>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}

        {/* <section class="team-section padding">
            <div class="container">
                <div class="section-heading mb-40 text-center">
                    <h4 class="sub-heading">Leadership team</h4>
                    <h2>Expert Dedicated <span>Team</span></h2>
                    <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 sm-padding">
                        <div class="team-box">
                            <div class="team-thumb">
                                <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/team-1.jpg" alt="team" />
                                <div class="shape-1"></div>
                                <div class="shape-2"></div>
                                <div class="team-content">
                                    <h3>Jhon Castellon <span>Engineering officer</span></h3>
                                </div>
                                <ul class="team-social">
                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                    <li><a href="#"><i class="fab fa-linkedin"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 sm-padding">
                        <div class="team-box">
                            <div class="team-thumb">
                                <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/team-2.jpg" alt="team" />
                                <div class="shape-1"></div>
                                <div class="shape-2"></div>
                                <div class="team-content">
                                    <h3>Fiorella Ibáñez <span>Marketing officer</span></h3>
                                </div>
                                <ul class="team-social">
                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                    <li><a href="#"><i class="fab fa-linkedin"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 sm-padding">
                        <div class="team-box">
                            <div class="team-thumb">
                                <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/team-2.jpg" alt="team" />
                                <div class="shape-1"></div>
                                <div class="shape-2"></div>
                                <div class="team-content">
                                    <h3>Zosé Carpio <span>Technology officer</span></h3>
                                </div>
                                <ul class="team-social">
                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                    <li><a href="#"><i class="fab fa-linkedin"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 sm-padding">
                        <div class="team-box">
                            <div class="team-thumb">
                                <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/team-3.jpg" alt="team" />
                                <div class="shape-1"></div>
                                <div class="shape-2"></div>
                                <div class="team-content">
                                    <h3>Kyle Frederick <span>Field officer</span></h3>
                                </div>
                                <ul class="team-social">
                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                    <li><a href="#"><i class="fab fa-linkedin"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}

        {/* <section class="cta-section padding">
           <div class="overlay"></div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 offset-lg-3">
                        <div class="cta-content text-center">
                            <div class="section-heading text-center">
                                <h4 class="sub-heading">Contact Us</h4>
                                <h2>Trusted By More Than 650,000 <br/>Happy<span> Peoples!</span></h2>
                                <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                            </div>
                            <a href="#" class="default-btn">Get a free quote <span></span></a>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}

        {/* <div class="sponsor-section">
            <div class="container">
                <div class="slider sponsor-carousel nav-style">
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-5.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-6.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-5.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-3.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                </div>
            </div>
        </div>  */}
   </Layout>
  );
}

export default Ourhistory;